export default __webpack_public_path__ + "static/media/DSC_0505.8a5a99ae.webp";